import axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppState } from "../../../store/root.reducer";

import * as NftActions from './nfts.actions';
import { Voucher } from "./nfts.reducer";
import { ApiClient } from "../../../utils/apiClient";

const BASE_API = process.env.REACT_APP_BASE_API;
axios.defaults.withCredentials = +process.env.REACT_APP_LOCAL !== 1;

const getCurrentSlot = (state: AppState) => state.nft.slot;
const getCurrentNFT = (state: AppState) => state.nft.selectedNFT; // could be nft or voucher

const apiClient = ApiClient(BASE_API);

function* lazyMint (action: {type: string, payload: Voucher}) {
    const { data } = yield call(apiClient.lazyMintRequest, action.payload);
    if(data.status) {
        yield put(NftActions.LazyMintSuccess(data.voucher));
    } else {
        yield put(NftActions.NftActionFailed(data.msg));
    }
}

function* resellNft (action: {type: string, payload: Voucher}) {
    const { data } = yield call(apiClient.lazyMintRequest, action.payload);
    if(data.status) {
        yield put(NftActions.ResellNFTSuccess(data.voucher));
    } else {
        yield put(NftActions.NftActionFailed(data.msg));
    }
}

function* listNFT (action: {type: string}) {
    const slot = yield select(getCurrentSlot);
    const voucher: Voucher = yield select(getCurrentNFT);

    const { data } = yield call(apiClient.listNftRequest, {slotPosition: slot, voucherId: voucher._id});
    if(data.status) {
        voucher.position = slot;
        yield put(NftActions.ListNFTSuccess(voucher));
    } else {
        yield put(NftActions.NftActionFailed(data.msg));
    }
}

function* unlistNFT() {
    const voucher: Voucher = yield select(getCurrentNFT);
    const { data } = yield call(apiClient.listNftRequest, {slotPosition: null, voucherId: voucher._id});
    if(data.status) {
        yield put(NftActions.UnlistNFTSuccess(voucher));
    } else {
        yield put(NftActions.NftActionFailed(data.msg));
    }
}

function* buyNFT(action: {type: string, payload: {
    newOwner: string, hash: string
}}) {
    const voucher: Voucher = yield select(getCurrentNFT);
    const payload = action.payload;
    const { data } = yield call(apiClient.buyNftRequest, {
        hash: payload.hash,
        newOwner: payload.newOwner,
        voucherId: voucher._id
    });
    if(data.status) {
        yield put(NftActions.BuyNFTSuccess(data.nft));
    } else {
        yield put(NftActions.NftActionFailed(data.msg));
    }
}

function* getListedVouchers(action: {type: string, payload: string}) {
    const { data } = yield call(apiClient.listedVouchersRequest);
    if(data.status) {
        const listed = data.vouchers.filter((voucher: Voucher) => voucher.listed === true);
        yield put(NftActions.GetVouchersSuccess(listed));
        
        // if(address) {
        //     const unlisedAndOwned = data.vouchers.filter((voucher: Voucher) => 
        //         (voucher.listed === false) && 
        //         (voucher.owner === address)
        //     );
        //     const { data: nfts } = yield call(unlistedNftsRequest, address);
        //     yield put(NftActions.GetWalletTokensSuccess([...unlisedAndOwned, ...nfts.nfts]));
        // }
    } else {
        yield put(NftActions.NftActionFailed(data.msg));
    }
}

function* getWalletTokens(action: {type: string, payload: string}) {
    const address = action.payload;
    const { data } = yield call(apiClient.unlistedNftsRequest, address);
    if(data.status) {
        yield put(NftActions.GetWalletTokensSuccess(data.nfts));
    } else {
        yield put(NftActions.NftActionFailed(data.msg));
    }
}

export default function* watchNftActions() {
    yield takeLatest(NftActions.LAZY_MINT, lazyMint);
    yield takeLatest(NftActions.LIST_NFT, listNFT);
    yield takeLatest(NftActions.GET_LISTED_VOUCHERS, getListedVouchers);
    yield takeLatest(NftActions.GET_WALLET_TOKENS, getWalletTokens);
    yield takeLatest(NftActions.UNLIST_NFT, unlistNFT);
    yield takeLatest(NftActions.BUY_NFT, buyNFT);
    yield takeLatest(NftActions.RESELL, resellNft);
}